import React from 'react'

const MenuVisibilityContext = React.createContext(null)

const MenuVisibilityProvider = ({ children }) => {
  const [visible, setVisible] = React.useState(true)

  const show = React.useCallback(() => setVisible(true), [])

  const hide = React.useCallback(() => setVisible(false), [])

  return (
    <MenuVisibilityContext.Provider value={{ visible, show, hide }}>
      {children}
    </MenuVisibilityContext.Provider>
  )
}

export default MenuVisibilityProvider

export const useMenuVisibility = () => React.useContext(MenuVisibilityContext)
